require('./bootstrap');
window.validate = require('jquery-validation');
require('select2');
require('./site-assets/search-places.js');
require('./site-assets/smart-search-places.js');
import 'bs5-lightbox'
require('../../node_modules/bootstrap-daterangepicker');
require('../../node_modules/bootstrap-daterangepicker/daterangepicker.css');
require('./bootstrap-editable');
require('./ythapp');
require('../../node_modules/intro.js/minified/introjs.min.css');
// require('./site-assets/users.js');
